export default "__VITE_ASSET__BBH0Ez6r__"